import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SITE_URL } from "../utils/constants";

const SEO = ({
  title = "English Tunnels - Professional English Courses Online",
  description = "Learn English with our comprehensive online courses. Improve your speaking, writing, and communication skills with expert instructors.",
  keywords = "English courses, learn English, online English classes, English speaking, English grammar",
  image = `${SITE_URL}/images/og-image.jpg`,
  type = "website",
  course = null,
}) => {
  const location = useLocation();
  const currentUrl = `${SITE_URL}${location.pathname}`;

  useEffect(() => {
    // Update document title
    document.title = title;

    // Update meta tags
    updateMetaTag("description", description);
    updateMetaTag("keywords", keywords);

    // Open Graph tags
    updateMetaTag("og:title", title, "property");
    updateMetaTag("og:description", description, "property");
    updateMetaTag("og:image", image, "property");
    updateMetaTag("og:url", currentUrl, "property");
    updateMetaTag("og:type", type, "property");
    updateMetaTag("og:site_name", "English Tunnels", "property");

    // Twitter Card tags
    updateMetaTag("twitter:card", "summary_large_image", "name");
    updateMetaTag("twitter:title", title, "name");
    updateMetaTag("twitter:description", description, "name");
    updateMetaTag("twitter:image", image, "name");

    // Canonical URL
    updateLinkTag("canonical", currentUrl);

    // JSON-LD structured data
    const structuredData = {
      "@context": "https://schema.org",
      "@type": course ? "Course" : "Organization",
      name: course ? course.title : "English Tunnels",
      description: description,
      url: currentUrl,
      image: image,
      ...(course && {
        provider: {
          "@type": "Organization",
          name: "English Tunnels",
        },
        offers: {
          "@type": "Offer",
          price: course.price,
          priceCurrency: "USD",
        },
      }),
    };

    updateJsonLd(structuredData);
  }, [title, description, keywords, image, type, currentUrl, course]);

  return null;
};

const updateMetaTag = (name, content, attribute = "name") => {
  let element = document.querySelector(`meta[${attribute}="${name}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attribute, name);
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
};

const updateLinkTag = (rel, href) => {
  let element = document.querySelector(`link[rel="${rel}"]`);
  if (!element) {
    element = document.createElement("link");
    element.setAttribute("rel", rel);
    document.head.appendChild(element);
  }
  element.setAttribute("href", href);
};

const updateJsonLd = (data) => {
  let script = document.querySelector('script[type="application/ld+json"]');
  if (!script) {
    script = document.createElement("script");
    script.type = "application/ld+json";
    document.head.appendChild(script);
  }
  script.textContent = JSON.stringify(data);
};

export default SEO;
